import type { IndicatorInstance, AcceleratorOscillatorSettings, ADXSettings, AroonSettings, MACDSettings, OsMASettings, RSISettings, StochasticOscillatorSettings } from "features/indicators/model";
import { INDICATOR_DEFAULT_SETTINGS } from "features/indicators/model";
import type { CandleWithFlag, ZoomRange } from "features/chart";
import { calcAcceleratorOscillator } from "../../model/calcAcceleratorOscillator";
import { drawAcceleratorOscillator } from "./drawAcceleratorOscillator";
import { calcADX } from "../../model/calcADX";
import { drawADX } from "./drawADX";
import { calcAroon } from "../../model/calcAroon";
import { drawAroon } from "./drawAroon";
import { calcMACD } from "../../model/calcMACD";
import { drawMACD } from "./drawMACD";
import { calcOsMA } from "../../model/calcOsMA";
import { drawOsMA } from "./drawOsMA";
import { calcRSI } from "../../model/calcRSI";
import { drawRSI } from "./drawRSI";
import { calcStochastic } from "../../model/calcStochastic";
import { drawStochastic } from "./drawStochastic";

export function renderOscillator(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  data: CandleWithFlag[],
  zoom: ZoomRange,
  instance: IndicatorInstance,
): void {
  const s = instance.settings ?? INDICATOR_DEFAULT_SETTINGS[instance.name];
  if (!s) return;
  const { start, end } = zoom;

  if (instance.name === "acceleratorOscillator") {
    const ao = s as AcceleratorOscillatorSettings;
    const pts = calcAcceleratorOscillator(data, ao.aoShortPeriod, ao.aoLongPeriod, ao.acSmaPeriod);
    drawAcceleratorOscillator(ctx, width, height, pts, start, end, ao);
  } else if (instance.name === "aDX") {
    const adx = s as ADXSettings;
    const lines = calcADX(data, adx.diLength, adx.adxSmoothing);
    drawADX(ctx, width, height, lines, start, end, adx);
  } else if (instance.name === "aroon") {
    const ar = s as AroonSettings;
    const lines = calcAroon(data, ar.period);
    drawAroon(ctx, width, height, lines, start, end, ar);
  } else if (instance.name === "mACD") {
    const m = s as MACDSettings;
    const res = calcMACD(data, m.fastPeriod, m.slowPeriod, m.signalPeriod);
    drawMACD(ctx, width, height, res, start, end, m);
  } else if (instance.name === "osMA") {
    const m = s as OsMASettings;
    const vals = calcOsMA(data, m.fastEmaPeriod, m.slowEmaPeriod, m.signalSmaPeriod);
    drawOsMA(ctx, width, height, vals, start, end, m);
  } else if (instance.name === "rSI") {
    const r = s as RSISettings;
    const vals = calcRSI(data, r.period);
    drawRSI(ctx, width, height, vals, start, end, r);
  } else if (instance.name === "stochasticOscillator") {
    const st = s as StochasticOscillatorSettings;
    const lines = calcStochastic(data, st.kPeriod, st.smoothingPeriod, st.dPeriod, st.movingAverage);
    drawStochastic(ctx, width, height, lines, start, end, st);
  }
}
